import "./testimonials-page-hero.css";

export default function TestimonialsHero() {
  return (
    <section className="oglitz-testimonials-page-hero">
      {/* Animated dots */}
      <div className="oglitz-testimonials-page-hero__dots">
        <span />
        <span />
        <span />
        <span />
      </div>

      <div className="oglitz-testimonials-page-hero__bg" />

      <div className="oglitz-testimonials-page-hero__container">
        <span className="oglitz-testimonials-page-hero__eyebrow">
          CLIENT TESTIMONIALS
        </span>

        <h1 className="oglitz-testimonials-page-hero__title">
          Trusted by Clients
          <span> Worldwide</span>
        </h1>

        <p className="oglitz-testimonials-page-hero__subtitle">
          From startups to global enterprises, organizations trust Oglitz to
          deliver secure, scalable, and high-performance digital solutions.
        </p>

        <div className="oglitz-testimonials-page-hero__trust">
          <span>✔ Global Clients</span>
          <span>✔ NDA Protected</span>
          <span>✔ Enterprise Security</span>
        </div>
      </div>
    </section>
  );
}
